import styled from 'styled-components';

const ModalFooter = styled.div`
  padding: 20px;
`;

export default ModalFooter;
